"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    computed: {
        key: function key() {
            return this.$vnode.key;
        }
    },
    data: function data() {
        return {
            internalValue: null // Must be updated by component
        };
    },
    methods: {
        update: function update(value) {
            this.internalValue = value;
            this.$emit('input', value);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/ConventionServitude/Mixins/TwoWayBinding.ts
// module id = 63
// module chunks = 0